const floor = Math.floor;
const max = Math.max;
const min = Math.min;

const blurTransferInt = (V, r, n, vertical) => {
    const [source, target] = V;
    const m = floor(source.length / n);
    const w = 2 * r + 1;
    const w1 = 1 / w;
    const ki = vertical ? m : 1;
    const kj = vertical ? 1 : n;
    const W = w * ki;
    const R = r * ki;

    for (let j = 0; j < m; ++j) {
        const k0 = kj * j;
        const kn = k0 + ki * (n - 1);
        for (let i = 0, sr = w * source[k0]; i < n + r; ++i) {
            const k = ki * i + kj * j;
            sr += source[min(k, kn)] - source[max(k - W, k0)];
            target[max(k - R, k0)] = sr * w1;
        }
    }
    V.reverse(); // target becomes V[0] and will be used as source in the next iteration
};

const blurTransfer = (V, r, n, vertical) => {
    if (!r) return; // radius 0 is a noop

    const iterations = 3, r0 = Math.floor(r);
    // for a non-integer radius, interpolate between floor(r) and ceil(r)
    if (r === r0) {
        for (let i = 0; i < iterations; i++) {
            blurTransferInt(V, r, n, vertical);
        }
    } else {
        const frac = r - r0, frac_1 = 1 - frac;
        const data = V[0].slice();
        for (let i = 0; i < iterations; i++) {
            blurTransferInt(V, r0 + 1, n, vertical);
        }
        const data_ceil = V[0];
        V[0] = data;
        if (r0 > 0) {
            for (let i = 0; i < iterations; i++) {
                blurTransferInt(V, r0, n, vertical);
            }
        }
        for (let i = 0; i < data.length; i++) {
            V[0][i] = V[0][i] * frac_1 + data_ceil[i] * frac;
        }
    }
};

// blur factory
const Blur = () => {
    let rx = 5;
    let ry = rx;
    let value;
    let width;
    const V = [];

    const blur = (data) => {
        const n = width || data.length;
        const m = Math.round(data.length / n);

        // reuse the V arrays if possible
        if (!value && V[0] && V[0].length === data.length) {
            V[0].set(data);
        } else {
            V[0] = value ? Float32Array.from(data, value) : Float32Array.from(data);
            V[1] = new Float32Array(data.length);
        }

        blurTransfer(V, rx, n, false);
        blurTransfer(V, ry, m, true);

        V[0].width = n;
        V[0].height = m;
        return V[0];
    };

    blur.radius = _ =>  _ === undefined ? (rx + ry) / 2 : (rx = ry = +_, blur);
    blur.radiusX = _ =>  _ === undefined ? rx : (rx = +_, blur);
    blur.radiusY = _ =>  _ === undefined ? ry : (ry = +_, blur);
    blur.width = _ => _ === undefined ? width : (width = Math.round(+_), blur);
    blur.value = _ => typeof _ === "function" ? (value = _, blur) : value;

    return blur;
};

export default Blur;
